import Swiper from "swiper/bundle";
export default class {
	constructor(options) {
		// OPTIONS
		this.defaults = {
			$el: undefined,

			// Default common swiper options
			swiperArgs: {
				// slidesPerView: 2.3,
				slidesPerView: "auto",
				grabCursor: true,
				loop: true,
				speed: 470,
				allowTouchMove: true,
				watchSlidesProgress: true,
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},
			},
		};

		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "swiper_slideshow";

		// DOM ELEMENT !!!!!!!!!!
		this.$el = this.options.$el;

		// init!!!!
		if (this.$el.length > 0) {
			this.init();
		}
	}

	init() {
		// vars
		/*
		this.$win = $(window);
		this.$doc = $(document);
		this.$html = $('html');
		this.$body = $( 'body' );
		*/

		this.initSlider(true);
		// this.onResize();
	}

	initSlider(b) {
		if (b) {
			if (this.$el.find(".swiper-slide").length <= 1) {
				return;
			}
			let args = this.options.swiperArgs;

			// add arrows navigation
			args.navigation = {
				nextEl: this.$el.find(".controls .next")[0],
				prevEl: this.$el.find(".controls .prev")[0],
			};

			if (this.$el.hasClass("feature-carousel")) {
				args.effect = "fade";
				args.allowTouchMove = true;
				args.grabCursor = true;
				args.fadeEffect = {
					crossFade: true,
				};
				args.pagination = {
					el: ".swiper-pagination",
					clickable: true,
				};

			}

			if (this.$el.hasClass("module-slideshow-overflow")) {
				args.spaceBetween = 32;
			}
			this.swiper = new Swiper(this.$el[0], args);
		} else {
			this.swiper.destroy(true, true);
			this.galleryThumbs.destroy(true, true);
		}

		//this.addEvents( b );
	}

	formatNumber(i) {
		return i < 10 ? "0" + i : i;
	}

	/*
    addEvents( b ){
		if ( b ){
		}
		else{
		}
		this.debounceResize(b);
    }
	*/

	/*
    debounceResize(b){
		if ( b ){
			// debounce resize
			this._debResize = _debounce( () => {
				this.onResize();
			}, 117 );
			this.$win.on( 'resize', this._debResize );
		}
		else{
			if ( this._debResize ){
				this._debResize.cancel();
				this.$win.off( 'resize', this._debResize );
			}        
		}
    }
    */

	/*
    onResize(){
    }
	*/

	/*
    attachEventsKeyBoard( b ){
		if ( b ){
			if  ( !this.events_keyboard_attach ){
				this.events_keyboard_attach =   true;      
				this.$doc.on( 'keydown' , (e) => {
					if ( !inView.is( this.$el[0] ) ){
						return;
					}
					if( e.which === 39 || e.which === 40 ){
						// right arrow or dn
						this.nextSlide( true );
					}
					else if ( e.which === 37 || e.which === 38 ){
						// left arrow or up
						this.nextSlide( false );
					}
				});
			}
		}
		else{
			this.$doc.off( 'keydown' );
			this.events_keyboard_attach =   false;
		}
    }
    */

	destroy() {
		this.initSlider(false);
		this.$el.removeData();
	}
}
